import { render, staticRenderFns } from "./AccordionSimpleCard.vue?vue&type=template&id=27932748&scoped=true"
import script from "./AccordionSimpleCard.vue?vue&type=script&lang=js"
export * from "./AccordionSimpleCard.vue?vue&type=script&lang=js"
import style0 from "./AccordionSimpleCard.vue?vue&type=style&index=0&id=27932748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27932748",
  null
  
)

export default component.exports